export default "__VITE_ASSET__B5wRr$Vv__"